/* Accordion motion, shared by every section that renders .nagi-acc__row.
   <details> has no transition of its own — closed, its content is not rendered,
   so CSS has nothing to animate from. The element stays a real <details>, so
   keyboard operation, find-in-page and the no-JS case all keep working. */
(function () {
  var motionOff = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* A group marked data-acc-exclusive keeps one row open at a time. Closing is
     done by clicking the open row's own summary rather than by setting .open,
     so the row leaves the same way it would under a finger and the animation
     below stays the only thing that moves it. Re-entry is safe: the row being
     clicked here is open, so it takes the closing branch and never comes back
     through this function. */
  function closeSiblings(row) {
    var group = row.closest('.nagi-acc');
    if (!group || !group.hasAttribute('data-acc-exclusive')) return;
    group.querySelectorAll('.nagi-acc__row[open]').forEach(function (other) {
      if (other === row) return;
      var sum = other.querySelector('.nagi-acc__sum');
      if (sum) sum.click();
    });
  }

  function bind(row) {
    if (row.dataset.accBound) return;
    var sum = row.querySelector('.nagi-acc__sum');
    var body = row.querySelector('.nagi-acc__body');
    if (!sum || !body || !body.animate) return;
    row.dataset.accBound = '1';

    var current = null;

    sum.addEventListener('click', function (e) {
      var opening = !row.open;
      /* Before the motion check, so the rule holds when motion is off too and
         the browser's own toggle is what opens the row. */
      if (opening) closeSiblings(row);

      if (motionOff.matches) return;
      e.preventDefault();
      if (current) current.cancel();

      if (opening) row.open = true;

      var full = body.scrollHeight;
      var frames = opening
        ? [{ height: '0px', opacity: 0 }, { height: full + 'px', opacity: 1 }]
        : [{ height: full + 'px', opacity: 1 }, { height: '0px', opacity: 0 }];

      current = body.animate(frames, {
        duration: opening ? 280 : 220,
        easing: opening ? 'cubic-bezier(0.22, 0.61, 0.36, 1)' : 'ease-in'
      });

      /* Closing runs the other way round: animate first, drop the open flag
         only once it lands, or the content vanishes on frame one. */
      current.onfinish = function () {
        if (!opening) row.open = false;
        /* Back to auto, or a row opened later by find-in-page — which never
           passes through here — would be stuck at whatever it measured. */
        body.style.height = '';
        current = null;
      };
    });
  }

  function bindAll() {
    document.querySelectorAll('.nagi-acc__row').forEach(bind);
  }

  bindAll();
  /* The theme editor swaps section markup in without a reload. */
  document.addEventListener('shopify:section:load', bindAll);
})();
